import { useEffect, useState } from "react";

const useDeviceType = () => {
    const getDeviceType=(width)=>{
        if(width<768){
            return "mobile"
        }else if(width>=768 && width<992){
            return "tablet" 
        }else{
            return "desktop"
        }
    }
    const [device, setDevice] = useState(getDeviceType(window.innerWidth));
    useEffect(() => {
      const handleResize=()=>{
        setDevice(getDeviceType(window.innerWidth))
      }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize); 
    }, [])
    
return device;
}
export default useDeviceType;